export default function AboutSection() {
  return (
    <section id="about" className="w-full scroll-mt-24 bg-background-100/60 py-12 md:py-16">
      <div className="container-x grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=cozy%20editorial%20newsroom%20desk%20with%20open%20notebooks%20and%20coffee%20and%20warm%20lamp%20light%2C%20timeline%20sketches%20on%20paper%2C%20warm%20cream%20and%20coral%20tone%2C%20no%20faces%2C%20calm%20thoughtful%20atmosphere&width=1200&height=900&seq=gua-about-2026&orientation=portrait"
            alt="每日看瓜编辑部的梳理桌面，笔记本与时间线草图"
            className="h-72 w-full object-cover lg:h-full lg:min-h-[360px]"
          />
        </div>

        <div>
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">关于本站</span>
          <h2 className="mt-1 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            我们只做一件事：<br className="hidden sm:block" />
            帮你看清瓜的全貌
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            网络上信息又多又碎，一个事件往往散落在上百条帖子里。每日看瓜把这些碎片按时间线重新拼接，
            用"起因、发酵、关键节点、结局"的结构帮你看清来龙去脉，而不只是停留在某一帧情绪里。
          </p>

          <div className="mt-6 grid grid-cols-3 gap-3">
            <div className="rounded-lg bg-background-50 p-4 ring-1 ring-background-200">
              <p className="font-heading text-2xl font-bold text-primary-600">268+</p>
              <p className="mt-1 text-xs text-secondary-700">事件时间线</p>
            </div>
            <div className="rounded-lg bg-background-50 p-4 ring-1 ring-background-200">
              <p className="font-heading text-2xl font-bold text-accent-700">90+</p>
              <p className="mt-1 text-xs text-secondary-700">全经过复盘</p>
            </div>
            <div className="rounded-lg bg-background-50 p-4 ring-1 ring-background-200">
              <p className="font-heading text-2xl font-bold text-secondary-700">每周三更</p>
              <p className="mt-1 text-xs text-secondary-600">持续更新节奏</p>
            </div>
          </div>

          <ul className="mt-6 space-y-2.5">
            {[
              '坚持公开事实：以官方声明与权威报道为素材，不传播未经证实的私密信息。',
              '坚持脉络清晰：只标注可公开确认的时间节点，反转出现便及时更新。',
              '坚持立场中立：让各方声音都有呈现，替你看清全貌，但不替你下结论。',
            ].map((t) => (
              <li key={t} className="flex items-start gap-2 text-sm text-foreground-700">
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-check-line text-[11px]" aria-hidden="true"></i>
                </span>
                {t}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}